import { createAsyncThunk } from '@reduxjs/toolkit';
import feathersClient from '../../feathers';

interface GenerateTimelineParams {
  knowledgebaseId: string;
  caseId: string;
  title?: string;
  language?: string;
}

/**
 * Thunk to generate a timeline for a knowledgebase
 */
export const generateTimelineThunk = createAsyncThunk(
  'timeline/generate',
  async (params: GenerateTimelineParams, { rejectWithValue }) => {
    try {
      const response = await feathersClient.service('actions').create({
        cmd: 'generate-timeline',
        knowledgebaseId: params.knowledgebaseId,
        caseId: params.caseId,
        title: params.title || 'Case Timeline',
        language: params.language || 'en'
      });

      // Backend wraps response in 'result' property
      const result = (response as any).result || response;

      if (result.success) {
        return {
          timelineId: result.timelineId,
          message: result.message
        };
      } else {
        return rejectWithValue(result.error || 'Failed to start timeline generation');
      }
    } catch (error: any) {
      return rejectWithValue(error.message || 'Error generating timeline');
    }
  }
);

